import styled from 'styled-components';
import ds from 'designsystem';

const MobileNavTitle = styled.h1`
  font-size: ${ds.fontSize('base')};
  font-family: ${ds.get('type.fontFamily.text')};
  color: ${ds.brand('regular')};
  padding: 0;
  font-weight: ${ds.get('type.fontWeight.bold')};
`;

export default MobileNavTitle;



// WEBPACK FOOTER //
// ./src/blocks/Navigation/MobileNavigation/MobileNavTitle.jsx